module.exports = __webpack_public_path__ + "static/customer_experience-e459eee14d5d110b8e814aa4daa3c1d6.jpg";